<template>
  <div class="pa-2" v-if="showAlert && alert">
    <div
      :class="['alert-banner', `alert-${alert.status.toLowerCase()}`]"
    >
      <div class="alert-container">
        <div class="alert-icon">
          <span v-if="alert.status === 'RED'">⚠️</span>
          <span v-else>⚠️</span>
        </div>
        <div class="alert-content">
          <div class="alert-title">
            {{ alert.status === "RED" ? "Atenção Crítica" : "Atenção" }}
          </div>
          <div class="alert-message">{{ alert.message }}</div>
          <router-link
            v-if="!isOnCalendarPage"
            :to="{
              path: '/administration-event',
              query: { data: currentDate },
            }"
            class="alert-link"
            title="Ver calendário de eventos"
          >
            📅 Ir para o calendário
          </router-link>
        </div>
        <button
          class="alert-close"
          @click="onDismiss"
          aria-label="Fechar alerta"
          title="Não exibir mais hoje"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AlertService from '@/services/alert'
import CookieService from '@/services/cookie'

export default {
  name: 'AlertBanner',
  data() {
    return {
      alert: null,
      showAlert: false
    }
  },
  computed: {
    cookieKey() {
      return `ALERT_DISMISSED_${new Date().toISOString().split('T')[0]}`
    },
    currentDate() {
      return new Date().toISOString().split('T')[0]
    },
    isOnCalendarPage() {
      return this.$route.path === '/administration-event'
    }
  },
  methods: {
    async loadAlert() {
      try {
        const dismissed = CookieService.get(this.cookieKey)
        if (dismissed === 'true') {
          this.showAlert = false
          return
        }

        const response = await AlertService.getAlert()
        this.alert = response.data || response
        
        if (!this.alert || !this.alert.status) {
          this.showAlert = false
          return
        }

        if (this.alert.status === 'YELLOW' || this.alert.status === 'RED') {
          this.showAlert = true
        } else {
          this.showAlert = false
        }
      } catch (error) {
        this.showAlert = false
      }
    },
    onDismiss() {
      CookieService.set(this.cookieKey, 'true')
      this.showAlert = false
    }
  },
  mounted() {
    this.loadAlert()
  }
}
</script>

<style scoped>
.alert-banner {
  width: 100%;
  padding: 12px 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 100;
}

.alert-yellow {
  background-color: #fff3cd;
  border-left: 5px solid #ffc107;
  color: #856404;
}

.alert-red {
  background-color: #f8d7da;
  border-left: 5px solid #dc3545;
  color: #721c24;
}

.alert-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.alert-icon {
  font-size: 20px;
  flex-shrink: 0;
  line-height: 1;
}

.alert-content {
  flex: 1;
  min-width: 0;
}

.alert-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}

.alert-message {
  font-size: 13px;
  margin-bottom: 8px;
}

.alert-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.alert-yellow .alert-link {
  color: #856404;
}

.alert-red .alert-link {
  color: #721c24;
}

.alert-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  text-decoration: underline;
}

.alert-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;
  border-radius: 4px;
}

.alert-close:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05);
}

.alert-red .alert-close {
  color: #721c24;
}

.alert-yellow .alert-close {
  color: #856404;
}
</style>

